<div class="settings-container">
  <!-- Header -->
  <div class="settings-header">
    <div class="title-section">
      <h1 i18n="@@settings.title">{{ appName }} Settings</h1>
      <p class="subtitle" i18n="@@settings.subtitle">Configure workspace-wide settings for {{ appName }} Agents</p>
    </div>
  </div>

  <!-- Workspace Secrets Section -->
  <div class="secrets-section">
    <div class="section-header">
      <div class="section-title">
        <h2>Workspace Secrets</h2>
        <p class="section-description">Create and manage secure secrets that can be accessed across your workspace.</p>
      </div>
      <p-button
        label="Add secret"
        icon="pi pi-plus"
        (click)="addSecret()">
      </p-button>
    </div>

    @if (isLoading) {
      <div class="loading-container">
        <p-progressSpinner />
        <p>Loading secrets...</p>
      </div>
    } @else if (secrets.length > 0) {
      <div class="secrets-list">
        @for (secret of secrets; track secret.id) {
          <p-card class="secret-card">
            <div class="secret-content">
              <div class="secret-icon">
                <i class="pi pi-lock"></i>
              </div>
              <div class="secret-info">
                <h3 class="secret-name">{{ secret.name }}</h3>
                <p class="secret-id">{{ secret.id }}</p>
              </div>
              <div class="secret-actions">
                <p-button
                  icon="pi pi-pencil"
                  severity="secondary"
                  [outlined]="true"
                  size="small"
                  (click)="editSecret(secret)"
                  pTooltip="Edit secret"
                  tooltipPosition="top">
                </p-button>
                <p-button
                  icon="pi pi-trash"
                  severity="danger"
                  [outlined]="true"
                  size="small"
                  (click)="deleteSecret(secret)"
                  pTooltip="Delete secret"
                  tooltipPosition="top">
                </p-button>
              </div>
            </div>
          </p-card>
        }
      </div>
    } @else {
      <div class="empty-state">
        <i class="pi pi-lock"></i>
        <p>No secrets configured yet</p>
        <p-button
          label="Add your first secret"
          icon="pi pi-plus"
          (click)="addSecret()">
        </p-button>
      </div>
    }
  </div>
</div>

<!-- Delete Confirmation Dialog -->
<app-delete-confirmation
  [(visible)]="deleteDialogVisible"
  [title]="'Delete Secret'"
  [subtitle]="'Are you sure you want to delete secret &quot;' + (deletingSecret?.name || '') + '&quot;? This action cannot be undone.'"
  [deleting]="isDeleting"
  (confirm)="onDeleteConfirm()"
  (cancel)="onDeleteCancel()" />

